import React from 'react';
import { ControlLayout } from 'components/ControlLayout';
import { useParams } from 'react-router';
import successIcon from 'assets/icons/exito_small.svg';
import warningIcon from 'assets/icons/warning_icon.svg';
import stopIcon from 'assets/icons/stop_icon.svg';
import errorIcon from 'assets/icons/error_icon.svg';
import successFrontIcon from 'assets/icons/exito_front.svg';
import carFrontOkIcon from 'assets/icons/car_front_ok.svg';
import { ResponseViewProps } from 'models/props/ResponseViewProps';
import { AttentionTime } from 'components/response/AttentionTime';
import { ResponseView } from 'components/response/ResponseView';
import {
	RESPONSE_VIEW_PORTABILIDAD_OK,
	RESPONSE_VIEW_ERROR,
	RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD,
	RESPONSE_VIEW_LO_SENTIMOS_LOAN,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_LOAN_ASYNC,
	RESPONSE_VIEW_DOCUMENT_UPDATE_OK,
	RESPONSE_VIEW_DOCUMENT_UPDATE_INCOMPLETE,
	RESPONSE_VIEW_LO_SENTIMOS_RESIMULACION,
	RESPONSE_VIEW_AUTOATENCION_EXITO,
	RESPONSE_VIEW_CONTACTO,
	RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK
} from 'constants/ResponseType';
import 'assets/scss/response-container.scss';
import { DATA_LAYERS } from 'constants/DataLayers';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

interface Params {
	response: string;
	dataLayer: string;
}

const getEmailFromStorage = (): string | undefined => {
	if (sessionStorage.getItem('HASH_EMAIL') != null) {
		const email = sessionStorage.getItem('HASH_EMAIL') as string;
		return JSON.parse(email).email as string;
	} else {
		return undefined;
	}
};

export const ResponseContainer = () => {
	const params = useParams<Params>();
	console.log(params);
	let history = useHistory();

	const ResponseData = new Map<string, ResponseViewProps>([
		[
			RESPONSE_VIEW_PORTABILIDAD_OK,
			{
				icon: successIcon,
				title: 'Tu oferta de portabilidad está en proceso',
				subtitle: '¡Tu solicitud ha sido recibida exitosamente!',
				body: (
					<div>
						<p>
							Verificaremos tus datos en tu actual financiera, luego serás contactado por un
							ejecutivo comercial de Crediautos en un <b>plazo máximo de 6 horas hábiles</b>.
						</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC,
			{
				icon: warningIcon,
				title: '¡Tu solicitud ha sido recibida exitosamente!',
				body: (
					<div style={{ marginTop: 26 }}>
						<p>
							Te enviaremos un correo electrónico{' '}
							{getEmailFromStorage() ? (
								<span>
									a <span style={{ fontWeight: 'bold' }}> {getEmailFromStorage()} </span>
								</span>
							) : (
								<span>al email que ingresaste</span>
							)}{' '}
							informando el estado de tu solicitud.
						</p>
						<p style={{ marginTop: 26, fontWeight: 'bold' }}>
							Si tu solicitud es pre-aprobada, pronto serás contactado por uno de nuestros
							ejecutivos de Crediautos.
						</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_ERROR,
			{
				icon: errorIcon,
				title: '¡Ups, algo salió mal!',
				body: (
					<div style={{ marginTop: 26 }}>
						<p>
							Nos encontramos presentando algunos problemas de nuestro lado por lo que{' '}
							<b>no es posible gestionar tu solicitud,</b> por favor inténtalo más tarde o
							comunícate con nosotros al
							<b> 600 370 9000</b>.
						</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD,
			{
				icon: stopIcon,
				title: '¡Lo sentimos!',
				body: (
					<div style={{ marginTop: 26 }}>
						<p>
							Agradecemos el interés de portar tu crédito a Crediautos, pero en esta oportunidad
							<b> no podemos acceder a tu solicitud</b> dado que esta no cumple con las{' '}
							<a
								className="response-link-condiciones"
								href="https://www.crediautos.cl/wp-content/uploads/2021/06/Condiciones_para_acceder_a_creditos.pdf"
							>
								{' '}
								Condiciones para Acceder a Créditos de nuestra institución
							</a>
							.
						</p>
					</div>
				),
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_LO_SENTIMOS_LOAN,
			{
				icon: stopIcon,
				title: '¡Lo sentimos!',
				body: (
					<div style={{ marginTop: 26 }}>
						<p>
							Agradecemos el interés de solicitar tu crédito con Crediautos, pero en esta
							oportunidad
							<b> no podemos acceder a tu solicitud</b> dado que esta no cumple con las{' '}
							<a
								className="response-link-condiciones"
								href="https://www.crediautos.cl/wp-content/uploads/2021/06/Condiciones_para_acceder_a_creditos.pdf"
							>
								{' '}
								Condiciones para Acceder a Créditos de nuestra institución
							</a>
							.
						</p>
					</div>
				),
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_LOAN_ASYNC,
			{
				icon: successFrontIcon,
				title: '¡Gracias por completar los datos!',
				body: (
					<div>
						<p>
							Esto nos ayudará a procesar mejor tu solicitud y darte una respuesta lo
							antes posible.
						</p>
						<p style={{ marginTop: 26 }}>
							Te contactaremos vía email.
						</p>
						
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_CONTACTO,
			{
				icon: successFrontIcon,
				title: '¡Gracias por completar los datos!',
				body: (
					<div>
						<p>
							Esto nos ayudará a procesar mejor tu solicitud y darte una respuesta mucho más
							precisa.
						</p>
						<p style={{ marginTop: 26, fontWeight: 'bold' }}>
							Pronto serás contactado por uno de nuestros ejecutivos
						</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_DOCUMENT_UPDATE_OK,
			{
				icon: warningIcon,
				title: '¡Tu documentación ha sido recibida correctamente!',
				body: (
					<div>
						<p>
							Hemos recibido toda tu documentación, dentro de poco un ejecutivo se contactará para
							informar el estado de tu solicitud.
						</p>
						<p style={{ marginTop: 26 }}>
							Ante dudas o consultas contáctanos a{' '}
							<a className="secondary-color" href="mailto:autoatencion@crediautos.cl">
								autoatencion@crediautos.cl
							</a>
						</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK,
			{
				icon: warningIcon,
				title: '¡Tu documentación ha sido recibida correctamente!',
				body: (
					<div>
						<p>
							Hemos recibido toda tu documentación, dentro de poco un ejecutivo se contactará para
							informar el estado de tu solicitud.
						</p>
						<p style={{ marginTop: 26 }}>
							Ante dudas o consultas contáctanos a{' '}
							<a className="secondary-color" href="mailto:autoatencion@crediautos.cl">
								autoatencion@crediautos.cl
							</a>
						</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_DOCUMENT_UPDATE_INCOMPLETE,
			{
				icon: successFrontIcon,
				title: '¡No te preocupes y reúne tus documentos!',
				body: (
					<div>
						<p>
							Te hemos enviado un correo a{' '}
							{getEmailFromStorage() ? (
								<span style={{ fontWeight: 'bold' }}>{getEmailFromStorage()}</span>
							) : (
								<span>al email que ingresaste</span>
							)}{' '}
							con un enlace donde podrás adjuntar tu documentación una vez que la hayas reunido.
						</p>
						<p style={{ marginTop: 16, fontWeight: 'bold', textAlign: 'left', marginBottom: 16 }}>
							Los documentos necesarios son:
						</p>
						<p className="body-bold gris-6" style={{ marginBottom: 8 }}>
							Trabajador dependiente
						</p>
						<ul style={{ marginLeft: 24, marginBottom: 8 }}>
							<li>3 últimas liquidaciónes de sueldo.</li>
							<li>Comprobante de domicilio (Ej: cuenta luz, agua, internet).</li>
							<li>12 cotizaciones de afp con Rut del empleador.</li>
						</ul>
						<p className="body-bold gris-6" style={{ marginBottom: 8 }}>
							Trabajador independiente
						</p>
						<ul style={{ marginLeft: 24 }}>
							<li>
								Carpeta Tributaria{' '}
								<span className="primary-color">(necesitarás tu clave única de SII)</span>.
							</li>
							<li>Comprobante de domicilio (Ej: cuenta luz, agua, internet).</li>
						</ul>
						<div
							style={{
								backgroundColor: 'rgba(78, 178, 235, 0.15)',
								marginTop: 32,
								borderRadius: 8,
								textAlign: 'center',
								boxSizing: 'border-box',
								padding: '8px',
							}}
						>
							Recuerda que tendrás{' '}
							<span className="body-bold">
								{' '}
								1 hora para subir toda la documentación y obtener tu descuento.
							</span>
						</div>
					</div>
				),
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_LO_SENTIMOS_RESIMULACION,
			{
				icon: stopIcon,
				title: '¡Ups, Lo sentimos!',
				body: (
					<div style={{ marginTop: 40 }}>
						<p>
							Al parecer el monto simulado <strong>supera tu capacidad de pago,</strong> te sugiero
							que vuelvas a simular otro monto con otro porcentaje de pie o número de cuotas o{' '}
							<strong>no podremos acceder a tu solicitud</strong> dado que esta no cumple con las
							<a
								className="response-link-condiciones"
								href="https://www.crediautos.cl/wp-content/uploads/2021/06/Condiciones_para_acceder_a_creditos.pdf"
							>
								{' '}
								Condiciones para Acceder a Créditos de nuestra institución
							</a>
							.
						</p>
					</div>
				),
				extras: (
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-around',
							alignItems: 'center',
							backgroundColor: '#00a9e3',
							color: 'white',
							position: 'relative',
							left: '-56px',
							width: '100%',
							marginTop: '16px',
							padding: '16px 56px',
						}}
						className="body-bold"
					>
						<p style={{ flex: 1 }}>¿No estas conforme con tu cuota?</p>{' '}
						<Button
							variant="outlined"
							style={{ color: 'white', flex: 1, borderColor: 'white' }}
							onClick={() => {
								history.push('/nueva-simulacion');
							}}
						>
							Vuelve a simular
						</Button>
					</div>
				),
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
		[
			RESPONSE_VIEW_AUTOATENCION_EXITO,
			{
				icon: carFrontOkIcon,
				title: '¡Felicidades tu crédito está pre-aprobado!',
				body: (
					<div>
						<p>
							En esta oportunidad no{' '}
							<span
								style={{
									fontWeight: 'bold',
								}}
							>
								necesitamos documentos para evaluar tu solicitud
							</span>
							. Dentro de poco serás contactado por un ejecutivo para continuar con tu atención.
						</p>
						<p>Ante dudas o consultas contáctanos al 600 390 9000</p>
					</div>
				),
				extras: <AttentionTime />,
				dataLayer: DATA_LAYERS.get(params.dataLayer),
			},
		],
	]);

	return (
		<div className="response-container">
			<ResponseView
				data={
					ResponseData.get(params.response)
						? ResponseData.get(params.response)
						: ResponseData.get(RESPONSE_VIEW_ERROR)
				}
			/>

			<ControlLayout
				inputError={false}
				disableBackButton={true}
				handleBackClick={() => null}
				handleNextClick={() => {
					if (params.response === RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK) {
						window.location.href = `${process.env.REACT_APP_BK_URL}`;
					} else {
						window.location.href = `${process.env.REACT_APP_WORDPRESS_URL}`;
					}
				}}
				buttonBackName={''}
				buttonNextName={'Ir a home'}
			/>
		</div>
	);
};
